exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main-title[data-v-69e969a9]{font-size:1.2rem;margin-bottom:4.8rem}.main-title .message[data-v-69e969a9]{line-height:2rem}.main-title h1[data-v-69e969a9]{line-height:2.6rem;margin:4.8rem 0 1.2rem;font-size:2.4rem}", ""]);

